import { type CategoryInfoInputType } from '../../category-info/types';
import { type CategorySelectorState } from '../../category-selector/hooks/useCategorySelector';
import { NONE_VALUE } from '../../category-tree/constant';

export const convertSelectedCategoryInfoToFormValue = (
  categoryInfo: CategorySelectorState,
): CategoryInfoInputType | undefined => {
  if (!categoryInfo.schoolType.selectedSchoolTypeNode) return undefined;

  return {
    schoolTypeId: categoryInfo.schoolType.selectedSchoolTypeNode.nodeId,
    gradeId: noneToUndefined(categoryInfo.grade.selectedGradeNode?.nodeId),
    semesterId: noneToUndefined(
      categoryInfo.semester.selectedSemesterNode?.nodeId,
    ),
    subject: categoryInfo.subject.selectedSubjectNode?.nodeId ?? '',
    subSubject: noneToUndefined(
      categoryInfo.subject.selectedSubSubjectNode?.nodeId,
    ),
    publisher: noneToUndefined(
      categoryInfo.publisher.selectedPublisher?.nodeId,
    ),
    customPublisher: noneToUndefined(
      categoryInfo.publisher.selectedCustomPublisher,
    ),
    isLastSchoolInfoSaved: categoryInfo.isLastSchoolInfoSaved,
  };
};

const noneToUndefined = (value?: string) => {
  if (!value) return undefined;
  if (value === NONE_VALUE) return undefined;
  return value;
};
